export default {
  savedColumns: {},
  savedGroups:[],
  dimensions: {},
  metrics: [],
}as{
  savedColumns: SavedColumns
  savedGroups: ColumnsGroupsSettingServerFormat[]
  dimensions: any,
  metrics: string[],
}
